import SupplierGrid from './SupplierGrid';

export default SupplierGrid;



// WEBPACK FOOTER //
// ./src/components/grids/SupplierGrid/index.jsx